import { TherapyJobV2 } from '../models/TherapyJobV2';

/** Measured minus planned flow rate; `null` when the measured flow rate is unknown, 0 without a planned one. */
export const flowRateDifference = (tj: Partial<TherapyJobV2>): number | null => {
  const planned = tj?.flowRatePlannedEdited || tj?.flowRatePlannedPrescribed || 0;
  const actual = tj?.therapyJobProgress?.currentFlowRate ?? null;

  if (planned === 0) {
    return 0;
  }

  if (actual === null) {
    return null;
  }

  return actual - planned;
};
